import(/* webpackMode: "eager" */ "/Users/bearjb/Repositories/bearjb/apps/blog/app/(routes)/posts/PostsList.tsx")